import { CompanyIdHeader } from '@sit/core';
import { axiosInstance, buildHeaders, getToken } from '@sit/openapi';
import { AxiosHeaders, } from 'axios';
import { getCompanyFromSessionStorage } from './utils/cross-platform-session-storage.js';
async function buildHeadersWithCompanyId(additionalHeaders, token) {
    const result = await getCompanyFromSessionStorage();
    const axiosHeaders = new AxiosHeaders(additionalHeaders);
    if (result?.id) {
        axiosHeaders.set(CompanyIdHeader, result.id);
    }
    return buildHeaders(axiosHeaders, token);
}
async function interceptRequestSent(config) {
    const token = getToken();
    config.headers = await buildHeadersWithCompanyId(config.headers || {}, token);
    return config;
}
export function initializeAxiosRequestInterceptor() {
    axiosInstance.interceptors.request.use(interceptRequestSent, (error) => Promise.reject(error));
}
//# sourceMappingURL=axios.js.map